import _ from "lodash";

const mutations = {
    init(state) {
        state.step = 1;
        state.requestData = {
            name: undefined,
            organizationName: undefined,
            cnpj: undefined,
            countryId: undefined,
            postcode: undefined,
            addressLine1: undefined,
            number: undefined,
            addressLine2: undefined,
            neighbourhood: undefined,
            stateId: undefined,
            cityId: undefined,
            nationality: undefined,
            cpf: undefined,
            passport: undefined,
            ssn: undefined,
            gender: undefined,
            birthDate: undefined,
            mother_name: undefined,
            title: undefined,
            email: undefined,
            mobile: undefined,
            password: undefined,
        };
    },
    mutateStep1Data(state, payload) {
        const {
            title,
            name,
            organizationName,
            cnpj,
            countryId,
            postcode,
            addressLine1,
            number,
            neighbourhood,
            addressLine2,
            stateId,
            cityId,
        } = payload;
        state.requestData.title = title;
        state.requestData.name = name;
        state.requestData.organizationName = organizationName;
        state.requestData.cnpj = cnpj;
        state.requestData.countryId = countryId;
        state.requestData.postcode = postcode;
        state.requestData.addressLine1 = addressLine1;
        state.requestData.number = number;
        state.requestData.neighbourhood = neighbourhood;
        state.requestData.addressLine2 = addressLine2;
        state.requestData.stateId = stateId;
        state.requestData.cityId = cityId;
        state.step = 2;
    },
    mutateStep2Data(state, payload) {
        const {
            nationality,
            cpf,
            passport,
            ssn,
            gender,
            email,
            mobile,
            birthDate,
            title,
            mother_name,
            password,
        } = payload;
        state.requestData.nationality = nationality;
        state.requestData.cpf = cpf;
        state.requestData.passport = passport;
        state.requestData.ssn = ssn;
        state.requestData.gender = gender;
        state.requestData.email = email;
        state.requestData.mobile = mobile;
        state.requestData.birthDate = birthDate;
        state.requestData.title = title;
        state.requestData.mother_name = mother_name;
        state.requestData.password = password;
        state.step = 3;
    },

    mutateStep3Data(state, payload) {
        const { signedDocumentId } = payload;
        state.requestData.signedDocumentId = signedDocumentId;
        state.step = 4;
    },
    mutateToPreviousStep(state) {
        state.step -= 1;
    },
};

export default mutations;
